<div class="details-container">

  <div class="details-header" style="background: url(assets/images/qe-sch2.jpg);">
      
    <div class="details-banner">
        <h1>Queen Elizabeth’s School, Barnet</h1>
        <h2>11 Plus (11+) Exam Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>Queen Elizabeth’s School (commonly known as QE Boys) is a reputable all-boys school located in the Barnet region of London, known for its long-standing tradition of providing exceptional educational instruction to pupils. Founded in 1573, the school’s extensive campus is nestled in the centre of Barnet, creating a conducive atmosphere for learning and personal growth. <br> The educational curriculum at QE Boys is systematically organised, encompassing a broad range of subjects that provide students with a solid foundation for choosing future careers. Some key disciplines include natural sciences, literature, language studies, mathematics, and visual arts. QE Boys highlights the significance of non-academic endeavours, encouraging participation in various clubs and organisations such as music, theatre, debate, and sports. <br>
      At the heart of the school’s principles is a dedication to academic distinction, an eagerness to acquire knowledge, and personal responsibility. QE Boys fosters independent thought and nurtures an environment that is both inclusive and diverse, enabling each learner to attain their fullest potential. It imbues values like integrity, respect, and civic duty, essential for students’ character development. <br>
      QE Boys boasts impressive academic accomplishments, with pupils consistently achieving remarkable results in their GCSE and A-level examinations. The students routinely secure placements at prestigious universities and establish successful careers across various sectors. As a result, QE Barnet has won multiple national awards for its high-performance standards.

      The school’s notable academic achievements, coupled with its emphasis on self-reliant thinking and inclusiveness, render Queen Elizabeth’s School an attractive option for parents seeking a first-rate education for their children.    </p>

    <div class="spacer"></div>

    <p>The consortium is dedicated to improving the efficiency and fairness of the admissions process for its member schools. Through collaboration, the schools share resources, expertise and administrative responsibilities, resulting in a unified and well-organised selection procedure. This collective effort aims to provide students from diverse backgrounds with equal opportunities to access high-quality education across the participating grammar schools.</p>


    <div class="spacer"></div>

    <p>⬇️ Read on to learn more about their exam and admissions process!</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Queen Elizabeth’s School, Barnet, 11 Plus (11+) Exam Information 2025</h2>

    <div class="spacer"></div>


    <p><strong>Address: </strong> Queen’s Road, Barnet EN5 4DQ</p>
    <p><strong>County:</strong> Hertfordshire / London Borough of Barnet</p>
    <p><strong>Admissions info:</strong> enquiries&#64;qebarnet.co.uk, 0208 441 4646</p>
    <p><strong>School type:</strong> Boys’ grammar</p>
    <p><strong>Number of places in Year 7: </strong> 180</p>
    <p><strong>Open Day date: </strong> July</p>
    <p><strong>11+ Exam date: </strong> September 2025</p>
    <p><strong>Pass mark: </strong> Aim for 70%+ in our practice tests. See below for more details.</p>
    <p><strong>Exam type / Board:</strong> GL Assessment</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Queen Elizabeth’s School (QE Boys) 11 Plus (11+) Admissions</h2>

    <div class="spacer"></div>

    <p>Admission to Queen Elizabeth’s School for Year 7 is by academic selection, following an entrance exam taken in September. There is an average of 10 applications for every Year 7 place. <br>

      To commence the admissions process, you are kindly advised to attend the school’s Open Day in July, which will give you and your child an opportunity to ask questions of interest and meet key members of staff. <br>
      
      Entrance to the school is based on performance in the 11+ Exam. When two students have the same score, they are ranked according to the straight-line distance from the school to their home. The student that lives closer is ranked higher.</p>


    <div class="spacer"></div>

    <h2>How to Apply for 11 Plus (11+) Entry to Queen Elizabeth’s School (QE Boys)</h2>

    <div class="spacer"></div>

    <p>To apply for a place at Queen Elizabeth’s School, Barnet, parents must complete both the school’s online registration form and the local authority (LA) Common Application Form (CAF). <br>

      Parents should be aware of the school and LA’s application dates, as late applications are very unlikely to be considered. </p>

    <div class="spacer"></div>

    <h2>Queen Elizabeth’s School, Barnet, 11 Plus (11+) Exam Format</h2>

    <p>The 11+ entrance exam at Queen Elizabeth’s School, Barnet, consists of two multiple-choice test papers in:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>English</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Mathematics</p></div>


    <div class="spacer"></div>

    <p>Both papers are taken by candidates in the same session. After the tests are completed, they will be marked and the scores will be age-standardised.
    </p>

    <p>Achieving the Secondary Transfer Test Score (STTS) does not guarantee a place at the school. Each grammar school in Buckinghamshire sets its own additional admissions criteria.</p>

    <p>The scores from the two tests will be combined to produce a single, overall entrance test score for each candidate. Candidates who achieve a combined score of 210 or higher will have met the standard required and will be considered for admission to the school.</p>


    <div class="spacer"></div>

    <h2>How to Prepare for the QE Boys 11 Plus (11+) Exam?</h2>

    <div class="spacer"></div>

    <p>To successfully prepare your child for the selective Queen Elizabeth’s School entrance exams, we recommend using practice tests. Our 11+ resources fully reflect the actual 11+ exam by covering all the question types that could come up, helping your child become familiar with the exam layout.     </p>

    <p>Coupled with a structured study plan, our practice tests will help you define any weak areas that require additional work at the earliest. They will also help you recognise your child’s strengths, resulting in a significant boost of their confidence in the lead up to the big day.</p>

    <p>Furthermore, your child will get used to answering questions quickly and effectively, under time pressure. Our practice papers are designed to be age-appropriate, yet challenging, and, as such, they are used successfully by hundreds of thousands of students every year.</p>

    <div class="spacer"></div>

    <p>Passing the test does not guarantee that your child will be offered a place. It simply means they have surpassed the required threshold. As such, it makes sense to aim for as high a score as possible.</p>

    <p>Don’t worry if your child is not scoring well in our practice papers from the outset. With targeted practice and focus, it’s possible to make big improvements in a short amount of time!</p>

    <div class="spacer"></div>

    <h2>Queen Elizabeth’s School 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

    <div class="spacer"></div>

    <p>Applicants who have achieved a combined score of 230 or higher will be considered for a place at QE Boys. Accordingly, a score of 70%+ in our 11+ practice tests should mean that your son is on track to pass the 11+ QE Boys test.
    </p>

    <p>Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the Queen Elizabeth’s 11+ exam. Click here to learn about this school’s performance in comparison to other schools in the area.</p>



  </div>

</div>

</div>